/**
 * Валюта ноги: ₽ или $, тем что принимает касса человека.
 *
 * Каталог площадки знает своё. Счёт может быть в другой валюте — тогда
 * сумма в форму должна быть в валюте счёта, иначе человек считает курс
 * в уме на скорости. Третьей валюты нет: у банка один курс, доллар.
 *
 * `pair` — плитка: оба знака рядом, нажатый = касса. `mark` — пад: сумма
 * читается как «49.14 $», клик по знаку циклит. Два знака плюс копировать
 * в одном ряду превращали число в панель иконок.
 */

export function CurEdit({
  cur,
  venue,
  onPick,
  face = 'pair',
}: {
  cur: 'RUB' | 'USD';
  venue: 'RUB' | 'USD';
  onPick: (next: 'RUB' | 'USD' | null) => void;
  face?: 'pair' | 'mark';
}): React.ReactElement {
  const pick = (next: 'RUB' | 'USD'): void => {
    onPick(next === venue ? null : next);
  };
  if (face === 'mark') {
    const next = cur === 'RUB' ? 'USD' : 'RUB';
    const rub = cur === 'RUB';
    return (
      <span className="nx-cur nx-cur--mark">
        <button
          type="button"
          className="nx-cur__mark"
          aria-label={rub ? 'сейчас рубли, нажать — доллары' : 'сейчас доллары, нажать — рубли'}
          title={rub ? 'сейчас рубли, нажать — доллары' : 'сейчас доллары, нажать — рубли'}
          onClick={(event) => {
            event.stopPropagation();
            pick(next);
          }}
        >
          {rub ? '₽' : '$'}
        </button>
      </span>
    );
  }
  return (
    <span className="nx-cur">
      <button
        type="button"
        className="nx-cur__btn"
        aria-pressed={cur === 'RUB'}
        title="рубли в кассу"
        onClick={(event) => {
          event.stopPropagation();
          pick('RUB');
        }}
      >
        ₽
      </button>
      <button
        type="button"
        className="nx-cur__btn"
        aria-pressed={cur === 'USD'}
        title="доллары в кассу"
        onClick={(event) => {
          event.stopPropagation();
          pick('USD');
        }}
      >
        $
      </button>
    </span>
  );
}
